<div class="mt-2">
  <ag-shr-editor-toolbar
    [title]="caption"
    [type]="type"
    [isEditVisible]="hasPermissionsToEdit"
    [agentDbId]="agentDbId"
    (clickEdit)="showEditorModal()"
  ></ag-shr-editor-toolbar>

  <div class="row" [ngClass]="type === LayoutGridType.short ? 'mb-3': 'my-2 px-3'">
    <div class="col-4 text-start" [ngClass]="{'mb-4': type === LayoutGridType.short}">
      <b> Do you have a Dietary or Personal Consideration? </b>
      @if (type === LayoutGridType.short) {
        <p>{{ dietaryConsiderationFormDetails?.[DietaryConsiderationKeys.hasDietaryOrPersonalConsideration] | empty }}</p>
      }
    </div>

    <div class="col-3 text-start" [ngClass]="{'mb-4': type === LayoutGridType.short}">
      <b>Consideration Type </b>
      @if (type === LayoutGridType.short) {
        <p>{{ dietaryConsiderationFormDetails?.[DietaryConsiderationKeys.dietaryConsiderationType] | dietaryConsiderationType | async | empty }}</p>
      }
    </div>

    <div class="col-5 text-start">
      <b>Description of Consideration(s) </b>
      @if (type === LayoutGridType.short) {
        <p class="ps-1">{{ dietaryConsiderationFormDetails?.[DietaryConsiderationKeys.dietaryConsideration] | empty }}</p>
      }
    </div>
  </div>

  @if (type !== LayoutGridType.short) {
    <div class="row my-2 px-3">
      <div class="col-4 text-start">
        {{ dietaryConsiderationFormDetails?.[DietaryConsiderationKeys.hasDietaryOrPersonalConsideration] }}
      </div>
      <div class="col-3 text-start">
        {{ dietaryConsiderationFormDetails?.[DietaryConsiderationKeys.dietaryConsiderationType] | dietaryConsiderationType | async }}
      </div>
      <div class="col-5 text-start">
        {{ dietaryConsiderationFormDetails?.[DietaryConsiderationKeys.dietaryConsideration] }}
      </div>
    </div>
  }
</div>

<ag-shr-modal-window
  [width]="'50vw'"
  [height]="'auto'"
  #dietaryConsiderationModalRef
  [title]="caption"
  [inProgress]="inProgress()"
  (onSaveClick)="saveAgentUpdates()"
  [onCloseModal]="handleClosePopup"
>
  <ag-shr-dietary-considerations-form
    [validationGroup]="validationGroup"
    [dietaryConsiderations]="dietaryConsiderationFormDetails"
  ></ag-shr-dietary-considerations-form>
</ag-shr-modal-window>
